export default {
    LOAD_DEPARTMENTS (state, departments) {
        state.items = departments
    },
    LOAD_DEPARTMENTS_ACTIVE (state, departments) {
        state.active = departments
    }
}